import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { SIZE } from "../../constants/size.js";
import { THEME } from "../../constants/theme.js";
import { cn as clsx } from "../../helpers/react.js";
import '../../assets/index42.css';const dark = "_dark_1w4dc_2";
const light = "_light_1w4dc_70";
const standardSize = "_standardSize_1w4dc_138";
const compactSize = "_compactSize_1w4dc_167";
const extendedSize = "_extendedSize_1w4dc_196";
const s = {
  dark,
  light,
  standardSize,
  compactSize,
  extendedSize
};
const THEME_CLASS_MAP = {
  [THEME.DARK]: s.dark,
  [THEME.LIGHT]: s.light,
  [THEME.CUSTOM]: s.custom
};
const SIZE_CLASS_MAP = {
  [SIZE.STANDARD]: s.standardSize,
  [SIZE.EXTENDED]: s.extendedSize,
  [SIZE.COMPACT]: s.compactSize
};
const withThemeAndSize = (Wrapped) => {
  const ComponentWithThemeAndSize = forwardRef((props, ref) => {
    const { size, theme, className, ...restProps } = props;
    const themeClass = theme && THEME_CLASS_MAP[theme];
    const sizeClass = size && SIZE_CLASS_MAP[size];
    const derivedClassName = clsx(themeClass, sizeClass, className);
    return /* @__PURE__ */ jsx(Wrapped, { ...restProps, className: derivedClassName, ref, size, theme });
  });
  ComponentWithThemeAndSize.displayName = `WithThemeAndSize(${Wrapped.displayName || Wrapped.name || "Component"})`;
  return ComponentWithThemeAndSize;
};
const _ThemeSlot = forwardRef(
  ({ size, theme, className, children, ...rest }, ref) => {
    const themeClass = theme && THEME_CLASS_MAP[theme];
    const sizeClass = size && SIZE_CLASS_MAP[size];
    return /* @__PURE__ */ jsx(Slot, { ...rest, className: clsx(themeClass, sizeClass, className), ref, children });
  }
);
const ThemeSlot = Object.assign(_ThemeSlot, {
  THEME_CLASS_MAP,
  SIZE_CLASS_MAP
});
export {
  ThemeSlot,
  withThemeAndSize
};
